import UsernameInput from './styled';

export default UsernameInput;
